import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let client: SupabaseClient | null = null;

export interface SupabaseAuthOptions {
  storage?: unknown;
  autoRefreshToken?: boolean;
  persistSession?: boolean;
  detectSessionInUrl?: boolean;
}

/**
 * Initialize the Supabase client. Call once at app startup before any service calls.
 * Pass authOptions to customize auth behavior (e.g. AsyncStorage for React Native).
 *
 * @example
 * // Web:
 * initSupabase(SUPABASE_URL, SUPABASE_ANON_KEY);
 * // React Native:
 * initSupabase(SUPABASE_URL, SUPABASE_ANON_KEY, { storage: AsyncStorage, detectSessionInUrl: false });
 */
export function initSupabase(
  url: string,
  anonKey: string,
  authOptions?: SupabaseAuthOptions,
): SupabaseClient | null {
  if (!client && url && anonKey) {
    client = createClient(url, anonKey, {
      auth: {
        autoRefreshToken: authOptions?.autoRefreshToken ?? true,
        persistSession: authOptions?.persistSession ?? true,
        detectSessionInUrl: authOptions?.detectSessionInUrl ?? true,
        ...(authOptions?.storage ? { storage: authOptions.storage as any } : {}),
      },
    });
  }
  return client;
}

/**
 * Get the initialized Supabase client. Returns null if not initialized (e.g. Phase A mock mode).
 */
export function getSupabase(): SupabaseClient | null {
  return client;
}
